import { render, staticRenderFns } from "./pay-really.vue?vue&type=template&id=28c778ae&scoped=true&"
import script from "./pay-really.vue?vue&type=script&lang=js&"
export * from "./pay-really.vue?vue&type=script&lang=js&"
import style0 from "./pay-really.vue?vue&type=style&index=0&id=28c778ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c778ae",
  null
  
)

export default component.exports